<div class="row">
    <div class="col">
       <agm-map
        [latitude]= "lat"
        [longitude]= "lon"
        [zoom]="16" (mapClick)="OnChangeMarker($event)">
        <agm-marker [latitude]="marker.lat" [longitude]="marker.lon" *ngIf="marker"></agm-marker>
      </agm-map>
    </div>
  </div>
  <div class="row">
    <div class="col">
        <button class="btn btn-success3 btn-block" end clear style="margin-bottom: 1%"
        (click)="setMarkerLocation()">Confirm Location</button>   
    </div>
    <div class="col">
        <button class="btn btn-success btn-block"  mat-dialog-close style="margin-bottom: 1%"
        (click)="setMarkerLocation()">Cancel</button>   
      </div>
  </div>